export default __webpack_public_path__ + "static/media/cer4.b14aa4d8.png";